const configs = `
automessage:
    standard:
        self:
            admin: 'unlimited'
    start:
        self:
            admin: 4
    pro:
        self:
            admin: 'unlimited'

faq:
    standard:
        self:
            admin: 'unlimited'
    start:
        self:
            admin: 'unlimited'
    pro:
        self:
            admin: 'unlimited'

'helpdesk':
    pro:
        self:
            admin: 'unlimited'


file:
    standard:
        self:
            admin: 100 #MB
    start:
        self:
            admin: 30 #MB
    pro:
        self:
            admin: 100 #MB

statistics:
    standard:
        overview:
            read: 'unlimited'
        responseTimeGraph:
            read: 'unlimited'
        activityGraph:
            read: 'unlimited'
        rating:
            read: 'unlimited'
    start:
        overview:
            read: 'unlimited'
    pro:
        overview:
            read: 'unlimited'
        responseTimeGraph:
            read: 'unlimited'
        activityGraph:
            read: 'unlimited'
        rating:
            read: 'unlimited'
feature:
    standard:
        rating:
            read: 'unlimited'
    start:
    pro:
        rating:
            read: 'unlimited'

exchange:
    pro:
        self:
            admin: 'unlimited'
`

export default configs



// WEBPACK FOOTER //
// ./src/config/PaymentConfigs.js